<body class="clouds">
  <!-- loading start -->
  <div id="loading">
    <div class="ripple"><span class="loader"></span></div>
  </div>
  <!-- end loading -->
  <!-- clouds container div -->
  <div id="clouds" class="fullscreen-preview">
    <img
      src="../../../../assets/images/my-links/onpassive-tab/cloud-1.png"
      alt="cloud-1"
      class="cloud1"
    />
    <img
      src="../../../../assets/images/my-links/onpassive-tab/cloud-2.png"
      alt="cloud-2"
      class="cloud2"
    />
    <img
      src="../../../../assets/images/my-links/onpassive-tab/cloud-3.png"
      alt="cloud-3"
      class="cloud3"
    />
    <img
      src="../../../../assets/images/my-links/onpassive-tab/cloud-4.png"
      alt="cloud-4"
      class="cloud4"
    />
  </div>
  <!-- end clouds container div -->
  <!-- page content -->
  <div class="countdown content initial">
    <div class="container-fluid">
      <div class="row justify-content-center top">
        <div class="col-lg-8">
          <h1 class="c-article__title">
            NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
          </h1>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-4">
          <div class="left_first_box">
            <div class="video_box acc_panel anim_in">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>

            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="animated-button1"
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              Become a Founder Now
            </a>
          </div>
        </div>
        <div class="col-lg-4 top_box">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(nov8)/img/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="right_box">
            <div class="launching_box">
              <div class="launching_box_one">
      
                <h1 class="font-weight-bold anim">LAUNCHING SOON!</h1>
              </div>
              <p>
                Failed in doing a business? Unhappy because you are in loss?
                Start smiling. Asking why, right? Presenting ONPASSIVE.. A
                solution formulated from years of experience and a lot of
                research & development to give you the perfect platform that
                will enable you to do any business effortlessly. Unlock the door
                to your happiness and a peaceful sleep at the end of the day.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page content -->
  <div class="header-wrapper">
    <div class="zoominheader">
      <div class="zoomoutheader">
        <div id="bg"></div>
      </div>
    </div>
  </div>
</body>
